import * as React from "react";
import { FormikProps } from "formik";
import { RouteComponentProps } from "@reach/router";
import { cx, css } from "@emotion/css";
import { FormValues } from "../../support/FormValues";
import bootstrapStyles from "../../css/bootstrap.module.css";
import ReviewHeader from "../../components/Review/ReviewHeader";

const reviewLabelCSS = css`
  font-size: 15px;
  color: #666;
  margin-bottom: 16px;
`;
const reviewDataCSS = css`
  font-weight: 700;
  color: #555;
  margin-bottom: 16px;
`;

interface ReviewProps extends RouteComponentProps {
  formikBag: FormikProps<FormValues>;
}

const ReviewFundSelection = ({ formikBag: { values } }: ReviewProps) => {
  return (
    <div className="reviewFundSelection-wrapper">
      <ReviewHeader
        label="Selected Funds and Allocations"
        navigation="/fundSelection"
      />

      {values.transferToSame && (
        <div className={bootstrapStyles.row}>
          <div className={bootstrapStyles["col-md-12"]}>
            <div className={bootstrapStyles.row}>
              <div className={bootstrapStyles["col-md-12"]}>
                <span className={cx(reviewDataCSS)} id="transferToSame">
                  Same as current account
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {values.fund1 && values.fund1Code && values.fund1Percent && (
        <div className={bootstrapStyles.row}>
          <div className={bootstrapStyles["col-md-12"]}>
            <div className={bootstrapStyles.row}>
              <div
                className={cx(bootstrapStyles["col-md-1"], reviewLabelCSS)}
                id="fund1Percent"
              >
                {values.fund1Percent}%
              </div>
              <div
                className={cx(bootstrapStyles["col-md-11"], reviewDataCSS)}
                id="fund1"
              >
                {values.fund1}
              </div>
            </div>
          </div>
        </div>
      )}
      {values.fund2 && values.fund2Code && values.fund2Percent && (
        <div className={bootstrapStyles.row}>
          <div className={bootstrapStyles["col-md-12"]}>
            <div className={bootstrapStyles.row}>
              <div
                className={cx(bootstrapStyles["col-md-1"], reviewLabelCSS)}
                id="fund2Percent"
              >
                {values.fund2Percent}%
              </div>
              <div
                className={cx(bootstrapStyles["col-md-11"], reviewDataCSS)}
                id="fund2"
              >
                {values.fund2}
              </div>
            </div>
          </div>
        </div>
      )}
      {values.fund3 && values.fund3Code && values.fund3Percent && (
        <div className={bootstrapStyles.row}>
          <div className={bootstrapStyles["col-md-12"]}>
            <div className={bootstrapStyles.row}>
              <div
                className={cx(bootstrapStyles["col-md-1"], reviewLabelCSS)}
                id="fund3Percent"
              >
                {values.fund3Percent}%
              </div>
              <div
                className={cx(bootstrapStyles["col-md-11"], reviewDataCSS)}
                id="fund3"
              >
                {values.fund3}
              </div>
            </div>
          </div>
        </div>
      )}
      {values.fund4 && values.fund4Code && values.fund4Percent && (
        <div className={bootstrapStyles.row}>
          <div className={bootstrapStyles["col-md-12"]}>
            <div className={bootstrapStyles.row}>
              <div
                className={cx(bootstrapStyles["col-md-1"], reviewLabelCSS)}
                id="fund4Percent"
              >
                {values.fund4Percent}%
              </div>
              <div
                className={cx(bootstrapStyles["col-md-11"], reviewDataCSS)}
                id="fund4"
              >
                {values.fund4}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewFundSelection;
